import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiService } from '../../services/apiService';

export const fetchCategories = createAsyncThunk(
    'categories/fetchCategories',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.getMaintenanceCategories(params);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch categories');
        }
    }
);

export const getCategoriesOverview = createAsyncThunk(
    'categories/getCategoriesOverview',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.getCategoriesOverview();
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch categories overview');
        }
    }
);

export const createCategoryAsync = createAsyncThunk(
    'categories/createCategory',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await apiService.createCategory(payload);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to create category');
        }
    }
);

export const updateCategoryAsync = createAsyncThunk(
    'categories/updateCategory',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await apiService.updateCategory(payload);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to update category');
        }
    }
);

export const deleteCategoryAsync = createAsyncThunk(
    'categories/deleteCategory',
    async (id, { rejectWithValue }) => {
        try {
            const response = await apiService.deleteCategory(id);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to delete category');
        }
    }
);

const initialState = {
    categoriesData: null,
    categoriesLoading: false,
    categoriesError: null,
    categoriesOverview: null,
    categoriesOverviewLoading: false,
    createCategoryLoading: false,
    updateCategoryLoading: false,
    deleteCategoryLoading: false,
};

const categorySlice = createSlice({
    name: 'categories',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchCategories.pending, (state) => {
                state.categoriesLoading = true;
                state.categoriesError = null;
            })
            .addCase(fetchCategories.fulfilled, (state, action) => {
                state.categoriesLoading = false;
                state.categoriesData = action.payload?.data || null;
                state.categoriesError = null;
            })
            .addCase(fetchCategories.rejected, (state, action) => {
                state.categoriesLoading = false;
                state.categoriesError = action.payload;
                state.categoriesData = null;
            })
            .addCase(getCategoriesOverview.pending, (state) => {
                state.categoriesOverviewLoading = true;
            })
            .addCase(getCategoriesOverview.fulfilled, (state, action) => {
                state.categoriesOverviewLoading = false;
                state.categoriesOverview = action.payload?.data || null;
            })
            .addCase(getCategoriesOverview.rejected, (state) => {
                state.categoriesOverviewLoading = false;
            })
            .addCase(createCategoryAsync.pending, (state) => {
                state.createCategoryLoading = true;
            })
            .addCase(createCategoryAsync.fulfilled, (state) => {
                state.createCategoryLoading = false;
            })
            .addCase(createCategoryAsync.rejected, (state) => {
                state.createCategoryLoading = false;
            })
            .addCase(updateCategoryAsync.pending, (state) => {
                state.updateCategoryLoading = true;
            })
            .addCase(updateCategoryAsync.fulfilled, (state) => {
                state.updateCategoryLoading = false;
            })
            .addCase(updateCategoryAsync.rejected, (state) => {
                state.updateCategoryLoading = false;
            })
            .addCase(deleteCategoryAsync.pending, (state) => {
                state.deleteCategoryLoading = true;
            })
            .addCase(deleteCategoryAsync.fulfilled, (state) => {
                state.deleteCategoryLoading = false;
            })
            .addCase(deleteCategoryAsync.rejected, (state) => {
                state.deleteCategoryLoading = false;
            });
    },
});

export default categorySlice.reducer;
